import React, { Children } from 'react'
import { View } from 'react-native'

export const FormRow = ({ children }: { children: React.ReactNode }) => (
  <View className="flex flex-row gap-8">
    {Children.map(children, (child) => (
      <View className="flex-1">{child}</View>
    ))}
  </View>
)

/**
 * Minimal wrapper for an internal form section (group of inputs).
 * No heading or divider for now; logic and styles can be added later.
 */
export default function FormSection({
  children,
}: {
  children: React.ReactNode
}) {
  return <View className="gap-8 px-8 pb-8">{children}</View>
}
